import React, { memo } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';

import AutocompleteDropdown from './autocompleteDropdown/AutocompleteDropdown';

import FormField from './FormField';

function DropdownFormField({
  label,
  name,
  value = null,
  options,
  inputProps,
  onChange,
  className,
  onInputChange,
  filterOptions,
  loading = false,
}) {
  return (
    <FormField label={label}>
      <FormControl variant="outlined" className={className}>
        <AutocompleteDropdown
          selectedData={value}
          onChange={(data) => onChange(data.value, name)}
          label={label}
          selectData={options}
          inputProps={inputProps}
          onInputChange={onInputChange}
          filterOptions={filterOptions}
          loading={loading}
        />
      </FormControl>
    </FormField>
  );
}

DropdownFormField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.oneOf([null])]),
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  inputProps: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  onInputChange: PropTypes.func,
  filterOptions: PropTypes.func,
  loading: PropTypes.bool,
};

DropdownFormField.defaultProps = {
  inputProps: {},
};

export default memo(DropdownFormField);
